<form class="aeg-u-bg-alt aeg-u-box-padding">
    <div class="aeg-u-bg-white aeg-u-box-padding">
        <div class="aeg-flex-rows-layout">
            <div class="aeg-flex-row">
                <div v-for="field in searchFields" :id="uniqueFieldId(field.key)" class="flex-0 aeg-flex-row-g1 items-center">
                    <RadioButton
                        :value="field.key"
                        v-model="searchField"
                        @input="searchFieldChanged"
                        name="filter"
                        :input-id="field.key"
                    />
                    <label :for="field.key">{{ field.label }}</label>
                </div>

            </div>

            <InputText v-if="correlationIdSelected" name="keyword" placeholder="Zoek op correlation-id" v-model="deadLetterCorrelationId" autocomplete="off" />
            <Select
                v-if="messageTypeSelected"
                :options="deadLetterMessageTypes"
                id="search-message-type"
                name="search-message-type"
                v-model="deadLetterMessageType"
            />
        </div>
    </div>
</form>
